<app-breadcrumbs
  [stepsLabels]="breadcrumbOptions.stepLabels"
  [stepsActions]="breadcrumbOptions.stepActions">
</app-breadcrumbs>

@if (tabs) {
  <app-tabs
    [tabs]="tabs">
  </app-tabs>
}

<br>

  <app-list-header
    name="bundle"
    [canCreate]="false"
    (onSearch)="search($event)">
  </app-list-header>

  <app-item-list
    [columns]="columns"
    [actions]="actions"
    [items$]="testBundlesRecurring$"
    (onItemClick)="view($event)"
    (onChangePage)="changePage($event.pageIndex, $event.pageSize)">
  </app-item-list>

  @if (isLoading) {
    <app-loader [transparent]="true"></app-loader>
  }
